let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4oEOI")).then(() => parcelRequire('dk4Fo'));